import { createContext, useContext } from 'react'

// Label id -> name for the account. Kept free of imports from pages so any hook can read
// it without an import cycle; LabelsProvider (LabelsContext.tsx) fills it.
export const LabelsContext = createContext<Record<string, string>>({})

export const useLabelMap = (): Record<string, string> =>
  useContext(LabelsContext)

// A row's label names, so an index page search for "Risk Team" finds the rows labelled
// with it.
export const labelNamesForSearch = (
  labelIds: string[],
  labelMap: Record<string, string>,
): string =>
  labelIds
    .map((id) => labelMap[id])
    .filter(Boolean)
    .join(' ')
